import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import TuttiArticoli from '../components/TuttiArticoli/TuttiArticoli';

const Articoli = ({pagesLeft,pagesRight,articles}) => {
  return (
    <div>
        <Navbar pagesLeft={pagesLeft} pagesRight={pagesRight}></Navbar>
        <TuttiArticoli articles={articles}></TuttiArticoli>
    </div>
  )
}

export default Articoli